import React from "react";
import { IonIcon } from "@ionic/react";
import { checkmarkCircle, ellipseOutline } from "ionicons/icons";

const CheckBox = ({ checked, size = "1.5rem", disabled, ...props }) => {
  return (
    <IonIcon
      icon={checked ? checkmarkCircle : ellipseOutline}
      style={{
        marginTop: "1rem",
        fontSize: size,
        cursor: disabled ? "not-allowed" : "pointer",
        color: checked ? "var(--ion-color-primary)" : "gray",
      }}
      {...props}
    />
  );
};

export default CheckBox;
